
<spike-base-page [breadcrumbItems]="breadcrumbItems()" [title]="title()" [subTitle]="subTitle()">
    <div actions>
        <p-button (click)="onInsert()" icon="pi pi-plus" severity="primary"  label="Nuovo" ></p-button>
    </div>

    <div header>   
        <div class="flex w-full items-end gap-4 mb-4">
    
            <div class="flex-1">
                <spike-field-wrapper label="Cerca" labelFor="omnisearch_orgpage">
                    <input pInputText 
                        id="omnisearch_orgpage"
                        placeholder="Inserisci una chiave di ricerca..." 
                        [ngModel]="filter().shortDescription" 
                        (ngModelChange)="onSearchByShortDesc($event)" 
                        class="w-full"/>
                </spike-field-wrapper>
            </div>

            <div>
                <p-buttongroup>
                    <p-button severity="secondary" label="Attivi" icon="pi pi-check" (onClick)="changeState(1)" [disabled]="filter().stateId==1" />
                    <p-button severity="secondary" label="Cancellati" icon="pi pi-times" (onClick)="changeState(0)" [disabled]="filter().stateId==0" />
                </p-buttongroup>
            </div>

        </div>
        <spike-etiquette-list 
            noLabelName="Tutti"
            [selectedId]="filter().etiquetteId" 
            [etiquetteList]="entityEtiquetteList()" 
            (onSelect)="searchByEtiquette($event)">
        </spike-etiquette-list>
    </div>


    @if(entityList() && entityList().length>0){
        <div>
            <div class="font-bold text-xl mb-1">Elenco risultati {{entityList().length}}</div>
            <div class="spike-table-card">
                <spike-organizations-table [etiquetteApi]="etiquetteApi()" [entityKey]="entityKey()" [items]="entityList()" (onSelect)="onSelect($event)"></spike-organizations-table>
            </div>
        </div>
        }
        @else {
            <spike-no-result></spike-no-result>
        }

</spike-base-page>   


@if(isDialogVisible()){
<spike-organization-side-panel 
    [entityApi]="entityApi()"
    [modelApi]="modelApi()"
    [etiquetteApi]="etiquetteApi()"
    [entityKey]="entityKey()" 
    [dataId]="selectedItem()!"  
    [isDialogVisible]="isDialogVisible()" 
    (onClose)="onClose()">
</spike-organization-side-panel>
}
